import React from "react"
import { LoginScreenHeader } from "./login-screen-header"

interface LoginScreenLayoutProps {
  children: React.ReactNode
  headerSubtitle: string
  headerTitle: string
  topContent?: React.ReactNode
  testId?: string
}

export const LoginScreenLayout: React.FC<LoginScreenLayoutProps> = ({
  children,
  headerSubtitle,
  headerTitle,
  topContent,
  testId,
}) => {
  return (
    <div data-testid={testId}>
      {topContent}
      <LoginScreenHeader subtitle={headerSubtitle} title={headerTitle} />
      <div className="space-y-3">{children}</div>
    </div>
  )
}
